module.exports = "/_next/static/images/689c30c7b5d408bfd89073ab6304ac40-secured-pre-ric.svg";